(function () {
  function money(cents) {
    var fmt = ((window.avenci && window.avenci.moneyFormat) || '${{amount}}').replace(/<[^>]*>/g, '');
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }
  function handleize(s) { return String(s).toLowerCase().replace(/['"]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }

  function init(root) {
    if (root.__avInit) return; root.__avInit = true;
    var product = JSON.parse(root.querySelector('[data-av-product]').textContent);
    var cfg = JSON.parse(root.querySelector('[data-av-config]').textContent);
    var form = root.querySelector('[data-av-form]');
    var idInput = root.querySelector('[data-av-variant-input]');
    var atc = root.querySelector('[data-av-atc]');
    var atcLabel = root.querySelector('[data-av-atc-label]');
    var gallery = root.querySelector('[data-av-gallery]');
    var dots = root.querySelector('[data-av-dots]');
    var optionEls = Array.prototype.slice.call(root.querySelectorAll('[data-av-option]'));
    var params = new URLSearchParams(location.search);
    var current = product.variants.filter(function (v) { return String(v.id) === params.get('variant'); })[0] ||
      product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
    var selected = current ? current.options.slice() : [];

    function findVariant(opts) {
      return product.variants.filter(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); })[0] || null;
    }

    function updateAvailability() {
      optionEls.forEach(function (el) {
        var idx = parseInt(el.getAttribute('data-av-option'), 10);
        el.querySelectorAll('.av-pill').forEach(function (b) {
          var opts = selected.slice(); opts[idx] = b.getAttribute('data-value');
          var v = findVariant(opts);
          b.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }

    function filterGallery(color) {
      if (cfg.colorIndex === null || !gallery) return;
      var key = handleize(color), items = gallery.querySelectorAll('.av-gallery__item'), any = false;
      items.forEach(function (it) { if (it.getAttribute('data-color') === key) any = true; });
      var shown = 0;
      items.forEach(function (it) {
        var show = !any || it.getAttribute('data-color') === key;
        if (show && shown >= 8) show = false;
        it.hidden = !show; if (show) shown++;
      });
      gallery.scrollLeft = 0;
      buildDots();
    }

    function buildDots() {
      if (!dots) return;
      var n = gallery.querySelectorAll('.av-gallery__item:not([hidden])').length;
      dots.innerHTML = n > 1 ? new Array(n + 1).join('<span></span>') : '';
      syncDots();
    }
    function syncDots() {
      if (!dots || !dots.children.length) return;
      var i = Math.round(gallery.scrollLeft / Math.max(1, gallery.clientWidth));
      Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    gallery && gallery.addEventListener('scroll', function () { window.requestAnimationFrame(syncDots); }, { passive: true });

    function apply() {
      current = findVariant(selected);
      optionEls.forEach(function (el) {
        var idx = parseInt(el.getAttribute('data-av-option'), 10);
        el.querySelector('[data-av-selected]').textContent = selected[idx];
        el.querySelectorAll('.av-pill').forEach(function (b) {
          var on = b.getAttribute('data-value') === selected[idx];
          b.classList.toggle('is-selected', on); b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
      });
      updateAvailability();
      var now = root.querySelector('[data-now]'), was = root.querySelector('[data-was]');
      if (current) {
        idInput.value = current.id;
        now.textContent = money(current.price);
        if (current.compare_at_price && current.compare_at_price > current.price) { was.textContent = money(current.compare_at_price); was.hidden = false; }
        else was.hidden = true;
        atc.disabled = !current.available;
        atcLabel.textContent = current.available ? cfg.atcText : cfg.soldText;
        if (cfg.isProductPage) { var u = new URL(location.href); u.searchParams.set('variant', current.id); history.replaceState({}, '', u); }
        document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: current } }));
      } else {
        atc.disabled = true; atcLabel.textContent = cfg.unavailableText;
      }
      if (cfg.colorIndex !== null) filterGallery(selected[cfg.colorIndex]);
    }

    root.addEventListener('click', function (e) {
      var pill = e.target.closest('.av-pill');
      if (pill) {
        var idx = parseInt(pill.closest('[data-av-option]').getAttribute('data-av-option'), 10);
        selected[idx] = pill.getAttribute('data-value'); apply(); return;
      }
      var opener = e.target.closest('[data-av-open]');
      if (opener) { openModal(opener.getAttribute('data-av-open')); return; }
      if (e.target.closest('[data-av-close]')) { closeModals(); return; }
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!current || !current.available) return;
      atc.classList.add('is-loading');
      var p = window.avenciCart ? window.avenciCart.add([{ id: current.id, quantity: 1 }])
        : fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: current.id, quantity: 1 }] }) }).then(function () { location.href = '/cart'; });
      Promise.resolve(p).catch(function () { alert('Sorry, that item could not be added. Please try again.'); }).then(function () { atc.classList.remove('is-loading'); });
    });

    /* ---------- modals ---------- */
    function openModal(name) {
      var m = root.querySelector('[data-av-modal="' + name + '"]'); if (!m) return;
      m.classList.add('is-open'); document.documentElement.style.overflow = 'hidden';
      var c = m.querySelector('.av-modal__close'); c && c.focus();
    }
    function closeModals() {
      root.querySelectorAll('.av-modal.is-open').forEach(function (m) { m.classList.remove('is-open'); });
      document.documentElement.style.overflow = '';
    }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModals(); });

    /* ---------- size guide ---------- */
    function rows(txt) { return String(txt || '').split(/\n+/).map(function (l) { return l.trim().split('|'); }).filter(function (r) { return r.length > 1; }); }
    var body = rows(cfg.bodyData), garment = rows(cfg.sizeData), unit = 'in';
    function fmtLen(inches) { var n = parseFloat(inches); if (isNaN(n)) return inches; return unit === 'in' ? n.toFixed(1).replace(/\.0$/, '') + '"' : (n * 2.54).toFixed(1).replace(/\.0$/, ''); }
    function renderTables() {
      var bt = root.querySelector('[data-av-body-table] tbody'), gt = root.querySelector('[data-av-garment-table] tbody');
      if (bt) bt.innerHTML = body.map(function (r) {
        var chest = unit === 'in' ? r[1] + '–' + r[5] + '"' : r[3] + '–' + r[7];
        var waist = unit === 'in' ? r[2] + '–' + r[6] + '"' : r[4] + '–' + r[8];
        return '<tr><td>' + r[0] + '</td><td>' + chest + '</td><td>' + waist + '</td></tr>';
      }).join('');
      if (gt) gt.innerHTML = garment.map(function (r) {
        var wt = parseFloat(r[6]), ht = parseFloat(r[7]);
        var wtTxt = isNaN(wt) ? r[6] : (unit === 'in' ? Math.round(wt) + ' lb' : Math.round(wt * 0.4536) + ' kg');
        var htTxt = isNaN(ht) ? r[7] : (unit === 'in' ? Math.floor(ht / 12) + "'" + Math.round(ht % 12) + '"' : Math.round(ht * 2.54) + ' cm');
        return '<tr><td>' + r[0] + '</td><td>' + fmtLen(r[1]) + '</td><td>' + fmtLen(r[2]) + '</td><td>' + fmtLen(r[3]) + '</td><td>' + fmtLen(r[4]) + '</td><td>' + fmtLen(r[5]) + '</td><td>' + wtTxt + '</td><td>' + htTxt + '</td></tr>';
      }).join('');
    }
    var units = root.querySelector('[data-av-units]');
    units && units.addEventListener('click', function (e) {
      var b = e.target.closest('[data-unit]'); if (!b) return; unit = b.getAttribute('data-unit');
      units.querySelectorAll('button').forEach(function (x) { x.classList.toggle('is-active', x === b); }); renderTables();
    });
    renderTables();

    /* ---------- find my size ---------- */
    var fms = root.querySelector('[data-av-modal="fms"]');
    if (fms) {
      var fit = 'regular', rec = null;
      var hCm = fms.querySelector('[data-av-h-cm]'), hFt = fms.querySelector('[data-av-h-ft]'), wKg = fms.querySelector('[data-av-w-kg]'), wLb = fms.querySelector('[data-av-w-lb]');
      hCm.addEventListener('input', function () { if (hCm.value) hFt.value = ''; });
      hFt.addEventListener('change', function () { if (hFt.value) hCm.value = ''; });
      wKg.addEventListener('input', function () { if (wKg.value) wLb.value = ''; });
      wLb.addEventListener('input', function () { if (wLb.value) wKg.value = ''; });
      fms.querySelector('[data-av-fit]').addEventListener('click', function (e) {
        var b = e.target.closest('[data-fit]'); if (!b) return; fit = b.getAttribute('data-fit');
        this.querySelectorAll('button').forEach(function (x) { x.classList.toggle('is-active', x === b); });
      });
      fms.querySelector('[data-av-fms-go]').addEventListener('click', function () {
        var hIn = hCm.value ? parseFloat(hCm.value) / 2.54 : parseFloat(hFt.value);
        var wLbV = wKg.value ? parseFloat(wKg.value) * 2.2046 : parseFloat(wLb.value);
        var err = fms.querySelector('[data-av-fms-err]');
        if (!(hIn >= 54 && hIn <= 90) || !(wLbV >= 80 && wLbV <= 440) || !garment.length) { err.style.display = 'block'; return; }
        err.style.display = 'none';
        // pick the size whose suggested weight/height is closest (weight counts more)
        var best = 0, bestScore = Infinity;
        garment.forEach(function (r, i) {
          var sw = parseFloat(r[6]), sh = parseFloat(r[7]);
          var score = Math.abs(wLbV - sw) / 12 + Math.abs(hIn - sh) / 2.5 * 0.6;
          if (score < bestScore) { bestScore = score; best = i; }
        });
        if (wLbV > parseFloat(garment[garment.length - 1][6]) + 15) best = garment.length - 1;
        if (fit === 'slim') best = Math.max(0, best - 1);
        if (fit === 'relaxed') best = Math.min(garment.length - 1, best + 1);
        rec = garment[best][0];
        fms.querySelector('[data-av-fms-size]').textContent = rec;
        fms.querySelector('[data-av-fms-note]').textContent = cfg.notes[fit] || '';
        fms.querySelector('[data-av-fms-form]').style.display = 'none';
        fms.querySelector('[data-av-fms-result]').style.display = 'block';
      });
      fms.querySelector('[data-av-fms-edit]').addEventListener('click', function () {
        fms.querySelector('[data-av-fms-form]').style.display = ''; fms.querySelector('[data-av-fms-result]').style.display = 'none';
      });
      fms.querySelector('[data-av-fms-use]').addEventListener('click', function () {
        optionEls.forEach(function (el) {
          var idx = parseInt(el.getAttribute('data-av-option'), 10);
          var name = (product.options[idx] && (product.options[idx].name || product.options[idx])) + '';
          if (/size/i.test(name) && product.variants.some(function (v) { return v.options[idx] === rec; })) selected[idx] = rec;
        });
        apply(); closeModals();
      });
    }

    apply();
  }

  function boot() { document.querySelectorAll('[data-av-pdp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
